import { Component, OnInit, ViewEncapsulation } from "@angular/core";

import { environment } from "src/environments/environment";
import { AppSessionService } from "src/app/shared/services/app-session/app-session.service";
import { ConfigService } from "../../../services/config/config.service";
import { BehaviorSubject, EMPTY, Observable } from "rxjs";
import { finalize, catchError } from "rxjs/operators";
import { SnackbarService } from "src/app/shared/services/snackbar/snackbar.service";
import { TranslateService } from "@ngx-translate/core";
import { SnackbarType } from "src/app/models/snackbar/snackbar.model";

@Component({
  selector: "app-about-dialog",
  templateUrl: "./about-dialog.component.html",
  styleUrls: ["./about-dialog.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AboutDialogComponent implements OnInit {
  isLoading$ = new BehaviorSubject<boolean>(false);
  appVersion = environment?.appVersion;
  envProduction = environment?.production;
  baseApiUrl: string;
  userManualLink =
    "../../../../../assets/UserManual_Aplicacao_Gestao_Frota_(Fleetsys)_v1.0.docx";
  apiVersions$: Observable<any>;

  constructor(
    public session: AppSessionService,
    private configService: ConfigService,
    private snackbarService: SnackbarService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.baseApiUrl = this.session.baseUrl + "/api-docs/swagger";
    this.loadApiVersions();
  }

  loadApiVersions() {
    this.isLoading$.next(true);

    this.apiVersions$ = this.configService.getApiVersions().pipe(
      catchError((error) => {
        this.snackbarService.show({
          message: this.translate.instant("TopNav.AboutDialog.apiVersionsLoadError"),
          type: SnackbarType.ERROR,
        });
        return EMPTY;
      }),
      finalize(() => this.isLoading$.next(false)),
    );
  }
}
